













































































import { DefaultOutAccountVue } from "fs-pb-vue2/vueModels/settings/DefaultOutAccountVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class DefaultOutAccount extends DefaultOutAccountVue {
  async mounted() {
    await this.init();
  }
}
